import { ChevronLeftSvg, ChevronRightSvg } from "@/public/svg";
import { memo } from "react";
import { twMerge } from "tailwind-merge";

import usePagination from "@/functions/usePagination";

function FooterTable({
  onPageChange,
  totalCount,
  siblingCount = 1,
  currentPage,
  pageSize,
  setPageSize,
}) {
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  // If there are less than 2 times in pagination range we shall not render the component
  if (currentPage === 0 || paginationRange?.length < 2) {
    return null;
  }

  let lastPage = paginationRange?.[paginationRange?.length - 1];

  function handleClick(mode) {
    if (mode == "add" && currentPage !== lastPage)
      return onPageChange(currentPage + 1);
    if (mode == "min" && currentPage !== 1)
      return onPageChange(currentPage - 1);
  }

  function generateRange(start, end, step) {
    return Array.from(
      { length: (end - start) / step + 1 },
      (_, i) => start + i * step
    );
  }
  const range = generateRange(10, totalCount, 10);

  return (
    <div className='flex justify-end gap-4 items-center mt-4 pt-4 border-t border-t-greyscaleGON-200'>
      <div className='p-2 border border-greyscaleGON-200 rounded cursor-pointer'>
        {currentPage <= 1 && (
          <select
            value={pageSize}
            defaultValue={pageSize}
            className='px-2'
            onChange={(val) => setPageSize(Number(val?.target?.value))}>
            {[
              range?.map((item, index) => (
                <option
                  key={index}
                  className='rounded-none bg-shadesGON-50 p2-regular text-greyscaleGON-700'
                  value={item}
                  selected={pageSize == item}>
                  {item}
                </option>
              )),
            ]}
          </select>
        )}
      </div>
      <div className='flex gap-4 items-center'>
        <div
          onClick={() => handleClick("min")}
          className='p-2 border border-greyscaleGON-200 rounded cursor-pointer'>
          <ChevronLeftSvg
            className={twMerge(
              "h-6 w-6",
              currentPage == 1
                ? "text-greyscaleGON-200"
                : "text-greyscaleGON-500"
            )}
          />
        </div>
        <p className='select-none xs:p1-regular text-xs'>Page {currentPage}</p>
        <div
          onClick={() => handleClick("add")}
          className='p-2 border border-greyscaleGON-200 rounded cursor-pointer'>
          <ChevronRightSvg
            className={twMerge(
              "h-6 w-6",
              currentPage == lastPage
                ? "text-greyscaleGON-200"
                : "text-greyscaleGON-500"
            )}
          />
        </div>
      </div>
    </div>
  );
}

export default memo(FooterTable);
